import { useState } from "react";

interface PopularQuestion {
  id: string;
  question: string;
  answer: string;
}

const questions: PopularQuestion[] = [
  {
    id: "question-1",
    question: "Step-by-step guide",
    answer:
      "You can cancel your subscription at any time by reaching out to our support team. Simply send us an email, and we'll help you with the cancellation process as quickly as possible.\n\nNo forms, no complicated steps — we'll handle everything for you.",
  },
  {
    id: "question-2",
    question: "Where is my refund?",
    answer:
      "Refunds typically take 14 business days to appear in your account after processing. If you haven't received your refund within this timeframe, please contact our support team with your transaction details.",
  },
  {
    id: "question-3",
    question: "I don't recognize this charge",
    answer:
      "If you don't recognize a charge, please check your email for receipts and transaction confirmations. The charge may appear under our parent company name \"Nova Vertex LTD\". If you still don't recognize it, please contact our support team immediately.",
  },
];

export default function PopularQuestionsSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="bg-[#111111]/60 backdrop-blur-sm rounded-2xl border border-white/[0.08] p-6 md:p-8 mb-6">
      <h3 className="text-lg font-semibold text-white mb-6 uppercase tracking-wider flex items-center">
        <span className="mr-2">&#128172;</span>
        Popular Questions
      </h3>
      <div className="space-y-0">
        {questions.map((q, idx) => (
          <div
            key={q.id}
            className={idx < questions.length - 1 ? "border-b border-white/[0.06]" : ""}
          >
            <button
              type="button"
              onClick={() => toggle(q.id)}
              className="flex items-center justify-between w-full p-4 text-left hover:bg-white/[0.03] transition-colors cursor-pointer rounded-lg"
            >
              <span className="text-white/90 font-medium text-sm md:text-base">{q.question}</span>
              <div className="w-6 h-6 flex items-center justify-center">
                <i
                  className={`ri-arrow-down-s-line text-white/40 transition-transform duration-300 ${openId === q.id ? "rotate-180" : ""}`}
                />
              </div>
            </button>
            {openId === q.id && (
              <div className="px-4 pb-4 text-white/60 text-sm leading-relaxed whitespace-pre-line">
                {q.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}